import styled from '@emotion/styled';
import { shouldForwardProp } from '@/utils/style.utils';
import { COLOR_VARIANTS, color } from '@tajawal/ct-web-design-system';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StateWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 8px;
  gap: 8px;

  .MuiChip-root {
    margin: 0;
  }
`;

const State = styled('div', { shouldForwardProp })<{ $isSelected: boolean }>`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: calc((100% - 10px) / 2);
  border-radius: 12px;
  border: 1px solid
    ${({ $isSelected }) => ($isSelected ? color(COLOR_VARIANTS.AQUA100) : color(COLOR_VARIANTS.GAINSBORO))};
  background: ${({ $isSelected }) => ($isSelected ? color(COLOR_VARIANTS.AQUA10) : color(COLOR_VARIANTS.WHITE))};
  box-sizing: border-box;
`;

export default {
  State,
  StateWrapper,
  Wrapper,
};
